/**
 * Principal Navigation Configuration
 * Shared across all Principal pages for consistent navigation
 * 
 * Sanjaya Brand Kit: Navy (#254B70), Orange (#F0A820), Teal (#258010)
 */
import { 
  Home, Eye, ClipboardList, UserCheck, 
  BarChart3, Sparkles, Calendar, BookOpen, CalendarClock, HelpCircle
} from 'lucide-react';

export const principalNavItems = [
  { path: '/principal/dashboard', label: 'Home', icon: Home },
  { path: '/principal/review-center', label: 'Review Center', icon: Sparkles },
  { path: '/principal/schedule', label: 'Schedule', icon: CalendarClock },
  { path: '/principal/session-history', label: 'Sessions', icon: ClipboardList },
  { path: '/principal/meetings', label: 'Meetings', icon: Calendar },
  { path: '/principal/observer-performance', label: 'Observers', icon: UserCheck },
  { path: '/principal/policy-book', label: 'Policy', icon: BookOpen },
  { path: '/principal/business', label: 'Business', icon: BarChart3 },
  { path: '/principal/support', label: 'Support', icon: HelpCircle },
];

export default principalNavItems;
